import { render, staticRenderFns } from "./EditIntegrationClient.vue?vue&type=template&id=2833bb06"
import script from "./EditIntegrationClient.vue?vue&type=script&lang=js"
export * from "./EditIntegrationClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports